import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import AssignmentIcon from "@mui/icons-material/Assignment";
import StyledRoot, { classes } from "../../utils/pageStyles";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Agendamentos } from "./Agendamentos/Agendamentos";
import { Atendimento } from "./Atendimento/Atendimento";
import { Link, useParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { Realizados } from "./Realizados/Realizados";

export function AtendimentoGrupo() {
  const { id } = useParams();
  const [value, setValue] = useState(id ? "2" : "1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (id === "realizados") return setValue("2");
    if ((id && !isNaN(id)) || id === "novo") return setValue("3");

    setValue("1");
  }, [id]);

  return (
    <StyledRoot className={classes.paper}>
      <Avatar className={classes.avatar}>
        <AssignmentIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Atendimento em Grupo
      </Typography>
      <Box sx={{ width: "100%", mt: 2 }}>
        <TabContext value={value}>
          <Box
            className="no-print"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <TabList onChange={handleChange} aria-label="Atendimento em Grupo">
              <Tab
                component={Link}
                to="/grupo/atendimento"
                label={
                  <Tooltip title="Lista de agendamentos">
                    <span>Agendamentos</span>
                  </Tooltip>
                }
                value="1"
              />
              <Tab
                component={Link}
                to="/grupo/atendimento/realizados"
                label={
                  <Tooltip title="Lista de atendimentos em grupo realizados">
                    <span>Atendimentos</span>
                  </Tooltip>
                }
                value="2"
              />
              <Tab
                component={Link}
                to="/grupo/atendimento/novo"
                label={
                  <Tooltip title="Realizar atendimento em grupo">
                    <span>Atender</span>
                  </Tooltip>
                }
                value="3"
              />
            </TabList>
          </Box>
          <TabPanel sx={{ px: 0 }} value="1">
            <Agendamentos />
          </TabPanel>
          <TabPanel sx={{ px: 0 }} value="2">
            <Realizados />
          </TabPanel>
          <TabPanel sx={{ px: 0 }} value="3">
            <Atendimento atendimentoId={id && !isNaN(id) ? id : undefined} />
          </TabPanel>
        </TabContext>
      </Box>
    </StyledRoot>
  );
}
